<template>
  <page-edicion>
    <page-header :title="duracionContrato.nombre" subtitle="Duración de contrato" back-to="/duracionesContrato" />
    <formulario :duracion-contrato="duracionContrato" @submit="actualizar" />
  </page-edicion>
</template>

<script>
import Formulario from "./Formulario.vue";
import * as duracionesContratoApi from "@/services/duracionesContrato.js";

export default {
  components: { Formulario },
  data() {
    return {
      duracionContrato: {},
    };
  },
  mounted() {
    this.cargar(this.$route.params.id);
  },
  methods: {
    cargar(id) {
      duracionesContratoApi.cargar(id).then((duracionContrato) => {
        this.duracionContrato = duracionContrato;
      });
    },
    actualizar() {
      duracionesContratoApi.actualizar(this.duracionContrato).then(() => {
        this.$messages.success("Se ha actualizado de duración del contrato");
        this.$router.push({ path: "/duracionesContrato" });
      });
    },
  },
};
</script>
